// import { BrowserRouter } from 'react-router-dom';
import { start } from '@jutro/app';
import { initDefaultGA, initDefaultMixpanel } from '@jutro/events';
import { LocaleService } from 'gw-portals-i18n-react';

// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
// TDIC: Added browser check
import isBrowserSupported from './browserBlocking';

import 'regenerator-runtime';

import App from './app/App';
import tdicThemeConfig from './themes/tdic/config';

const { trackingConfig = {}, authentication = {} } = appConfig;

const gaTrackingId = trackingConfig.GA_TRACKING_ID;
const mixpanelTrackingId = trackingConfig.MIXPANEL_TRACKING_ID;

if (gaTrackingId) {
    initDefaultGA(trackingConfig);
}
if (mixpanelTrackingId) {
    initDefaultMixpanel(trackingConfig);
}

let cloudAuthConfig = {};
if (authentication.authServer === 'okta') {
    cloudAuthConfig = authentication.servers.okta;
}
const emptyApp = () => {
    return null;
};

// TDIC: Set empty application to be loaded when browser is not supported
const entryApp = !isBrowserSupported() ? emptyApp : App;

// start(App, {    TDIC: Changed to use variable set above
start(entryApp, {
    rootId: 'root',
    messageLoader: LocaleService.loadMessages,
    coreMessageLoader: LocaleService.loadCoreMessages,
    config: [cloudAuthConfig],
    refreshOnLocaleChange: true,
    themeConfig: tdicThemeConfig,
    routerBasename: '/account-management',
    onInit: () => {
        LocaleService.register();
    },
    appName: {
        id: 'digital.appName',
        defaultMessage: 'CustomerEngage Account Management'
    },
    appDescription: 'Description', // ToDo
    modalProvider: 'default', // ToDo
});
